import ModalWrapper from '../../common/Modal/ModalWrapper';

import companyInvestmentImg from '../../../../images/pricing-page/investment.png';
import companyExitImg from '../../../../images/pricing-page/exit.png';
import companyGrowthImg from '../../../../images/pricing-page/growth.png';

import advisorInvestmentImg from '../../../../images/pricing-page/advisorInvestment.png';
import advisorExitImg from '../../../../images/pricing-page/advisorExit.png';
import advisorGrowthImg from '../../../../images/pricing-page/advisorGrowth.png';

import investorInvestmentImg from '../../../../images/pricing-page/investorInvestment.png';
import investorExitImg from '../../../../images/pricing-page/investorExit.png';
import investorGrowthImg from '../../../../images/pricing-page/investorGrowth.png';

const PricingPageJourney = ({ modaldata, userType = "company" }) => {
    let image = companyInvestmentImg;
    if (["company", "user", 'member'].includes(userType?.toLowerCase()) && modaldata?.toLowerCase()?.includes("exit")) {
        image = companyExitImg;
    } else if (["company", "user", 'member'].includes(userType?.toLowerCase()) && modaldata?.toLowerCase()?.includes("growth")) {
        image = companyGrowthImg;
    } if (userType === "advisor" && modaldata?.toLowerCase()?.includes("investment")) {
        image = advisorInvestmentImg;
    } if (userType === "advisor" && modaldata?.toLowerCase()?.includes("exit")) {
        image = advisorExitImg;
    } else if (userType === "advisor" && modaldata?.toLowerCase()?.includes("growth")) {
        image = advisorGrowthImg;
    } if (userType === "investor" && modaldata?.toLowerCase()?.includes("investment")) {
        image = investorInvestmentImg;
    } if (userType === "investor" && modaldata?.toLowerCase()?.includes("exit")) {
        image = investorExitImg;
    } else if (userType === "investor" && modaldata?.toLowerCase()?.includes("growth")) {
        image = investorGrowthImg;
    }

    return (
        <ModalWrapper modalType="pricingPage" modalCardClasses="maw90 bg38" customStyle={{ padding: '0px' }}>
            <img src={image} alt="Pricing Journey" className='w100' />
        </ModalWrapper>
    );
};

export default PricingPageJourney;
